// Libs
import React, { useContext, useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Typography } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { Demanda, getDemanda, getHistoricoDemanda, HistoricoDemanda, obterDadosAprovacaoTotvs } from '@app/api/demanda';
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import { Visibility } from '@app/components';

//Files

//Utils

const { Title } = Typography;

const columnsHistorico = [
  {
    title: 'Responsável',
    dataIndex: 'usuarioResponsavel',
    key: 'usuarioResponsavel',
    width: '15%',
  },
  {
    title: 'Descrição',
    dataIndex: 'descricao',
    key: 'descricao',
    width: '30%',
  },
  {
    title: 'Data / Hora',
    dataIndex: 'dataHoraFormatada',
    key: 'dataHoraFormatada',
    width: '15%',
  },
  {
    title: 'Status Anterior',
    dataIndex: 'statusAnterior',
    key: 'statusAnterior',
    width: '20%',
  },
  {
    title: 'Novo Status',
    dataIndex: 'statusNovo',
    key: 'statusNovo',
    width: '20%',
  },
];

const columnsInfoAprovacao: ui.ColumnProps<any>[] = [
  {
    title: 'Tipo',
    dataIndex: 'tipo',
  },
  {
    title: 'Aprovador',
    dataIndex: 'aprovador',
  },
  {
    title: 'Aprovador Alternativo',
    dataIndex: 'aprovadorAlternativo',
  },
  {
    title: 'Data Geração',
    dataIndex: 'dataGeracaoString',
  },
  {
    title: 'Data Aprovação',
    dataIndex: 'dataAprovacaoString',
  },
  {
    title: 'Situação',
    dataIndex: 'situacao',
  },
  {
    title: 'Rejeição',
    dataIndex: 'rejeicao',
  },
];

const AbaHistorico = () => {
  const { match } = ui.useRouter();
  const [id, setId] = useState(match.path.split('/')[3]);
  const [selectedItem, setSelectedItem] = useState<Demanda>();

  const { demandaData } = useContext(QuestionarioContextProvider);
  const [dataAprovacao, setdataAprovacao] = useState<any[]>([]);

  useEffect(() => {
    if (demandaData) {
      obterDadosAprovacaoTotvs(demandaData.id)
        .then((data: any) => setdataAprovacao(data));
    }
  }, [demandaData]);

  useEffect(() => {
    getDemanda(id).then(data => setSelectedItem(data));
  }, [id]);

  const [data] = ui.usePromise(
    () => (selectedItem ? getHistoricoDemanda(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem],
    [] as HistoricoDemanda[],
  );

  return (
    <>
      <PerfectScrollbar>
        <ui.Widget>
          <ui.Row>
            <Title level={4}>Histórico</Title>
            <ui.Table
              columns={columnsHistorico}
              rowKey="index"
              dataSource={data}
              pagination={false} />
          </ui.Row>
        </ui.Widget>

        <Visibility
          visible={dataAprovacao.length > 0}
        >
          <ui.Widget>
            <ui.Row>
              <Title level={4}> Informações de Aprovação da Requisição e Compra no Totvs </Title>
              <ui.Table
                style={{ paddingInline: '4px' }}
                columns={columnsInfoAprovacao}
                dataSource={dataAprovacao}
                pagination={false} />
            </ui.Row>
          </ui.Widget>
        </Visibility>
      </PerfectScrollbar>
    </>
  );
};
export default AbaHistorico;
